import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref } from "@nuxtjs/composition-api";
import { SwiperOptions } from "swiper";
import type { HomeTempCompanyItem } from "~/services/model/product";
import VResponsive from "~/components/VResponsive/VResponsive.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleCompany',
  props: {
    title: null,
    items: null
  },
  setup(__props: any) {



function hexToRgb(hex: string) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

function toRgb(hex: string) {
  let rgb = hexToRgb(hex);

  return rgb ? [rgb.r, rgb.g, rgb.b].join(",") : hex;
}
const colors = [
  "#F4E5B8",
  "#F0DED4",
  "#D1EBE0",
  "#F8F1EE",
  "#EDFAF6",
  "#F7F4D4",
  "#F0DAC3",
  "#F9E6E6",
];

function getItemStyles(index: number) {
  let color = colors[index % colors.length];
  return {
    background: `linear-gradient(180deg, rgba(${toRgb(
      color
    )}, .8) 0%, #F8F8F8 100%)`,
    // border: `1px solid rgba(${toRgb(color)}, .6)`
  };
}
const swiperComponentRef = ref();
const swiperComponentinstance = computed(
  () => swiperComponentRef.value?.$swiper
);
const swiperOptions: SwiperOptions = {
  slidesPerView: 4,
  spaceBetween: 0,
  navigation: {
    nextEl: ".j_next",
    prevEl: ".j_prev",
  },
  on: {
    // reachBeginning: () => state.isBeginning = true,
    slideChange() {
      Object.assign(state, {
        isBeginning: this.isBeginning,
        isEnd: this.isEnd,
      });
    },
  },
};

const state = reactive({
  isBeginning: true,
  isEnd: false,
});
const onNext = () => swiperComponentinstance.value?.slideNext();
const onPrev = () => swiperComponentinstance.value?.slidePrev();

return { __sfc: true,hexToRgb, toRgb, colors, getItemStyles, swiperComponentRef, swiperComponentinstance, swiperOptions, state, onNext, onPrev, VResponsive }
}

})